import { Component, Input, OnInit } from '@angular/core';
import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME, LINE_OF_BUSINESS_ENUM, EntitlementsHelperService, ENTITLEMENTS, USER_ROLE } from '@ptl/account-management';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { BrandingConfigurationService } from '@ptl/brand';
import { RedirectService } from 'src/app/angular-elements/shared/services/redirect.service';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { HttpHeaders } from '@angular/common/http';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-benefits-manager-sso',
    templateUrl: './benefits-manager-sso.component.html',
    styleUrls: ['./benefits-manager-sso.component.scss'],
    standalone: false
})
export class BenefitsManagerSsoComponent implements OnInit {

  @Input() benefitsManagerLabel: string;
  hasEntitlements = false;
  noEntitlementsMessage

  loginData: UserInfoStateStructure;
  lob: LINE_OF_BUSINESS_ENUM = LINE_OF_BUSINESS_ENUM.SMALL_GROUP;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private brandService: BrandingConfigurationService,
    private entitlementService: EntitlementsHelperService,
    private redirectService: RedirectService,
    private httpClient: HTTPWrapperContext,
    private authoringMode: AuthoringModeService,
    private snackBar: MatSnackBar


  ) { }

  async ngOnInit() {

    this.lob = await this.entitlementService.getCurrentLobPromise();
    const loginData: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    this.hasEntitlements = await this.entitlementService.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.SMALL_GRP_QUOTES, this.lob, loginData?.userInfo?.role as USER_ROLE);

    if (!this.authoringMode.getAuthoringMode() || this.hasEntitlements) {
      this.loginData = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

      this.submitBenefitsManagerSso();
    }
  }

  async submitBenefitsManagerSso() {
    const samlDataRaw = await this.getSamlData();
    var samlData = (samlDataRaw.payload.split("SAMLResponse=")[1]);
    samlData = samlData.replace(/>\s+</g, "><");

    if (samlData) {
      var bsiUrl = "";
      var regex = /(d|t)env.?\./;
      if (regex.test(window.location.href)) {
        bsiUrl = "https://identity-api-proj05.prod.simon365.com/identity/api/v1/saml?client_name=bcbsmnHmhs";
      } else {
        bsiUrl = "https://identity-api.prod.simon365.com/identity/api/v1/saml?client_name=bcbsmnHmhs";
      }

      let postParams = { target: bsiUrl, SAMLResponse: samlData }
      const alertDuration = 1000; // ms

      this.snackBar.open(`Redirecting to new location`, 'OK', {
        duration: alertDuration,
        panelClass: 'positive-panel-class'
      });

      this.redirectService.post(postParams);
      setTimeout(() => {
        history.back();
      }, alertDuration);
    }
  }

  getSamlData() {
    let sessionUrl = "https://" + window.location.hostname + "/cmcrst/x-services/healthcheck";

    const payload = {
      "baseMessage": {
        "headerVersion": "1.0"
      },
      "payload": {
        "firstName": this.loginData.userInfo.firstName,
        "lastName": this.loginData.userInfo.lastName,
        "userID": this.loginData.userId,
        "selectedAgency": this.loginData.userInfo.agencyInfo.selectedAgencies['SMALL_GROUP'].agencyId,
        "role": this.loginData.userInfo.role,
        "returnUrl": window.location.href,
        "sessionUrl": sessionUrl,
        "agencies": this.getBsiAgencies()
      }
    }

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: `/cmcrst/x-services/secure/bsisso`,
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded()
      }),
      POST_OR_PUT_PAYLOAD: payload
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
    return this.httpClient.makeRequest<any>(requestConfig);
  }

  getBsiAgencies() {

    var agencies = [];
    var condensedAgency;
    let selectedAgency = this.loginData.userInfo.agencyInfo.selectedAgencies[this.lob];

    if (this.loginData.basicUserInfo.userType.toUpperCase() === "AGENT") {

      var singleAgency;

      for (var agency in this.loginData.userInfo.agencies) {
        if (this.loginData.userInfo.agencies[agency].agencyId === selectedAgency.agencyId) {
          singleAgency = this.loginData.userInfo.agencies[agency];
          break;
        }
      }

      condensedAgency = {};

      if (singleAgency.agentACSId) {
        condensedAgency.agentID = singleAgency.agentACSId;
      }

      condensedAgency.agencyID = singleAgency.agencyId;

      condensedAgency.entitlementGeneralAgencyAdmin = this.entitlementService.entitlementValueByNameAndLob(ENTITLEMENTS.GENERAL_AGENCY_ADMIN, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
      condensedAgency.entitlementNewSmallGroupQuotes = this.entitlementService.entitlementValueByNameAndLob(ENTITLEMENTS.SMALL_GRP_QUOTES, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
      condensedAgency.entitlementRenewals = this.entitlementService.entitlementValueByNameAndLob(ENTITLEMENTS.RENEWALS, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
      agencies.push(condensedAgency);

    } else {

      for (var agency in this.loginData.userInfo.agencies) {
        condensedAgency = {};

        if (this.loginData.userInfo.agencies[agency].agentACSId) {
          condensedAgency.agentID = this.loginData.userInfo.agencies[agency].agentACSId;
        }

        condensedAgency.agencyID = this.loginData.userInfo.agencies[agency].agencyId;
        condensedAgency.entitlementGeneralAgencyAdmin = this.entitlementService.entitlementValueByNameAndLob(ENTITLEMENTS.GENERAL_AGENCY_ADMIN, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
        condensedAgency.entitlementNewSmallGroupQuotes = this.entitlementService.entitlementValueByNameAndLob(ENTITLEMENTS.SMALL_GRP_QUOTES, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
        condensedAgency.entitlementRenewals = this.entitlementService.entitlementValueByNameAndLob(ENTITLEMENTS.RENEWALS, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);

        agencies.push(condensedAgency);
      }
    }

    return agencies;
  }


}
